import { InjectionToken } from '@angular/core';
import { IStatusBarConfig } from './statusBar-config.model';

export const StatusBarConfig: InjectionToken<IStatusBarConfig> = new InjectionToken('StatusBarConfig');




// WEBPACK FOOTER //
// C:/Users/user/projects/ansyn/src/app/packages/status-bar/models/statusBar.config.ts